
const $toggleItems = $('.js-toggle-item');
const $toggleContents = $('.js-toggle-content');

/* Открытие/закрытие табов-аккордеонов */
App.H.on('click', '.js-toggle-link', function(e) {
    e.preventDefault();

    const $thisLink = $(this);
    const _isAccordeon = $thisLink.closest('.js-toggle-item').hasClass('_accordeonable');
    const $item = $thisLink.closest('.js-toggle-item');
    const $itemContent = $item.find('.js-toggle-content');
    const _isActive = $item.is('._active');
    const thisBtnText = _isActive ? $thisLink.data('default') : $thisLink.data('replace');

    // Если принцип аккордеон, то закрываем все остальные табы и открываем текущий
    if (_isAccordeon) {
        $toggleItems.removeClass('_active');
        $toggleContents.stop().slideUp(350);
        $toggleItems.find('.js-toggle-link').html($thisLink.data('default'));
        $thisLink.html(thisBtnText);

        if (_isActive) {
            $item.find('.js-toggle-content').stop().slideUp(350);
        } else {
            $item.addClass('_active');
            $item.find('.js-toggle-content').stop().slideDown(350);
        }
    } else {
        $item.toggleClass('_active');
        $itemContent.stop().slideToggle(350);
        $thisLink.html(thisBtnText);
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/Accordeon.js